
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRunningColorIec as ObiRunningColorIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-running-color-iec.js';
 
 
 

 
 export const ObiRunningColorIec = createComponent({
   react: React,
   tagName: 'obi-running-color-iec',
   elementClass: ObiRunningColorIecElement,
   events: {
     
   }
  });
 
 